import React, { useContext, useState } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../utils/context";
import ModalSave from "../../common/ModelSave";
import { CancelButton, SaveButton } from "../../common/Button";
import { Row, Col, Form, InputGroup, Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import classNames from "classnames";

const AddOffCanvance = (props) => {
  const { postData } = useContext(Context);
  const [showModal, setShowModal] = useState({ code: 0, message: "" });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = async (data) => {
    try {
      const DataToSend = new FormData();
      DataToSend.append("name", data?.name?.trim());
      const response = await postData(`/admin/career/qualification`, DataToSend);
      const ok = !!response?.success;
      setShowModal({ code: response?.code, message: ok ? response?.message : response?.errors || response?.message });
      setTimeout(() => {
        setShowModal({ code: 0, message: "" });
        if (ok) props.handleClose(); // stay open on error so the text is not lost
      }, 1000);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <Modal {...props} onHide={props.handleClose} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">Add Qualification</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={(e) => e.preventDefault()} role="form">
            <Row>
              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <Form.Label>Qualification</Form.Label>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        placeholder="Qualification"
                        className={classNames("", { "is-invalid": errors?.name })}
                        {...register("name", {
                          required: "Qualification is required",
                          validate: (v) => v.trim().length > 0 || "Qualification is required",
                          maxLength: { value: 200, message: "Maximum 200 characters" },
                        })}
                      />
                    </InputGroup>
                    {errors.name && <span className="text-danger">{errors.name.message}</span>}
                  </Form.Group>
                </div>
              </Col>

              <Row className="mt-5 pb-3">
                <div className="d-flex justify-content-center">
                  <Link>
                    <CancelButton name={"Cancel"} handleClose={props.handleClose} />
                  </Link>
                  <SaveButton name={"Save"} handleSubmit={handleSubmit(onSubmit)} />
                </div>
              </Row>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>

      <ModalSave message={showModal.message} showErrorModal={showModal.code ? true : false} />
    </>
  );
};

export default AddOffCanvance;